export const VERTEX_SHADER = 'vs';
export const FRAGMENT_SHADER = 'fs';
//# sourceMappingURL=constants.js.map


// WEBPACK FOOTER //
// ./~/@luma.gl/shadertools/dist/esm/lib/constants.js